import '@babel/polyfill';
import React from 'react';
import { createRoot } from 'react-dom/client';
import { ThemeProvider } from '../scn/theme1';
import Login from './login';

function App() {
  return (
    <ThemeProvider>
      <React.StrictMode>
          <Login />
      </React.StrictMode>
    </ThemeProvider>
  );
}

const container = document.getElementById('login-root');
if (container) {
  const root = createRoot(container);
  root.render(<App />);
}
